export default {
  public: {
    title: "Public web",
    subtitle: "Set up your public website here",

    generalForm: {
      title: "General",
      publicate: "Publish your web",
      status: {
        label: "Publication status",
        options: {
          enabled: "Enabled",
          disabled: "Disabled"
        }
      },
      seeWeb: "See web",
      url: "URL of your portal",
      powered: {
        title: 'Remove "Powered by Lázzaro" from footer',
        under: "The message will appear at the bottom of your website",
        options: {
          enabled: "Enabled",
          disabled: "Disabled"
        }
      }
    },
    chooseTemplate: {
      title: "Template",
      template1: "Modern",
      template2: "Classic",
      template3: "Minimalist",
      modalText: "Choose a template",
      templateChangeModal: {
        title: "The template is being changed",
        subtitle:
          "Cool you are gonna see the new template! this might take few minutes. It is the perfect moment to prepare the coffee"
      }
    },
    personalizeWebForm: {
      title: "Personalize your website",
      subtitle: "Choose the elements that suit you",
      form: {
        logo: "Logo",
        mainTypography: "Main Typography",
        secondTypography: "Secondary Typography",
        fonts: {
          label: "Font",
          roboto: "Roboto",
          arial: "Arial"
        },
        buttonsColor: "Button color",
        menuColor: "background color",
        menuTextColor: "Menu text color",
        footerColor: "Footer color",
        logoHelper: "60x60. Máx 25MB"
      }
    },
    homepageForm: {
      title: "Homepage",
      subtitle: "First impressions are what matter",
      form: {
        image: "Main Image",
        title: "Title",
        subtitle: "Subtitle",
        imageHelper: "180x60. Máx 25MB",
        titleHelper: "(Máx 80 characters)",
        subtitleHelper: "(Máx 140 characters)",
        buttons: {
          1: "Button 1",
          2: "Button 2"
        },
        links: {
          1: "Link of button 1",
          2: "Link of button 2"
        }
      }
    },
    whoWeAreForm: {
      title: "Who we are",
      subtitle: "Show what you do to the world",
      form: {
        image: "Main image",
        title: "Title",
        subtitle: "Subtitle",
        imageHelper: "180x60. Máx 25MB",
        titleHelper: "(Max 80 characters)",
        subtitleHelper: "(Max 140 characters)",
        description: "Description"
      },
      features: {
        title: "Company Features",
        icon: {
          1: "Icon 1",
          2: "Icon 2",
          3: "Icon 3",
          4: "Icon 4",
          help: "60x60. Max 25MB"
        },
        titles: "Title {index}",
        descriptions: {
          1: "Descriptive text 1",
          2: "Descriptive text 2",
          3: "Descriptive text 3",
          4: "Descriptive text 4"
        },
        button: "Button",
        link: "Link of the button"
      },
      design: {
        color: "Background color",
        layout: {
          tooltip: "Layout",
          title: "Main Title",
          subtitle: "Description",
          item: {
            title: "Title",
            subtitle: "Descriptive text"
          }
        }
      }
    },

    logosForm: {
      title: "Logos",
      subtitle: "We have left this space for you to add logos of cool things",
      logo: {
        label: "Logo",
        help: "180x60, max 25MB",
        limit: "You can not add more than 10 logos",
        delete: "logo Deleted successfully",
        error: "Error deleting logo"
      }
    },

    websiteStatus: {
      publishWebsite: {
        title: "We are publishing your website this can take up to 5 minutes.",
        subtitle:
          "Remember you can unpublish it again whenever you one clicking the same button and saving the changes in the “save”. "
      },

      unpublishWebsite: {
        title:
          "We are unpublishing your website this can take up to 5 minutes.",
        subtitle:
          "Remember you can publish it again whenever you one clicking the same button and saving the changes in the “save”. "
      }
    },

    brandForm: {
      title: "Appearance",
      logo: {
        label: "Logo",
        help: "180x60, max 25MB"
      },
      mainImg: {
        label: "Primary image",
        help: "180x60, max 25MB"
      },
      orgName: "Company name",
      colour: {
        first: "Theme colour 1",
        second: "Theme colour 2"
      }
    },

    contactForm: {
      title: "Contact Form",
      subtitle:
        "Allow a potential customer to contact you. Configure the title and subtitle of your contact page.",
      form: {
        title: "Title",
        subtitle: "Subtitle"
      },
      phone: "Phone no.",
      location: "Location"
    },

    contentForm: {
      title: "Content",
      subtitle: "Choose what sections will appear in your public website.",
      sectionStatus: {
        title: "Selection status",
        options: {
          enabled: "Enabled",
          disabled: "Disabled"
        }
      },
      projects: "Projects",
      donations: "Donators",
      partners: "Members",
      market: "Shop",
      courses: "Courses",
      reviews: "Reviews",
      impact: "Impact data",
      events: "Events",
      volunteers: "Volunteers"
    },

    footer: {
      title: "Footer",
      subtitle: "Allows a potential customer to contact you.",
      socialForm: {
        title: "Social media",
        facebook: "Link to Facebook",
        twitter: "Link to Twitter",
        whatsapp: "Link to Whatsapp",
        whatsappHelp:
          "No special characters like '+' or spaces, see <a target='_blank' href='https://faq.whatsapp.com/502291734918768/?helpref=uf_share&cms_platform=android'>here</a> for WhatsApp Business users or <a target='_blank' href='https://faq.whatsapp.com/5913398998672934/?helpref=uf_share'>here</a> for WhatsApp users. Ex: https://wa.me/1XXXXXXXXXX",
        linkedin: "Link to LinkedIn",
        web: "Link to Secondary web",
        instagram: "Link to Instagram"
      },
      termsForm: {
        title: "Terms and conditions, legal notice and privacy policy",
        add: "Choose files",
        terms:
          "Upload your terms and conditions, legal notice and privacy policy so that users can accept them",
        transparencyDescription: "Transparency description",
        accountability: "Transparency and accountability"
      }
    },

    teamForm: {
      title: "Team",
      subtitle:
        "Create the profile of each of the members of your company. With the link to their Linkedin it will be much easier to give visibility to them and the company.",
      header: {
        title: "Title",
        subtitle: "Subtitle",
        titleHelperText: "(Max 80 characters)",
        subtitleHelperText: "(Max 180 characters)"
      },
      teamMembers: {
        title: "Team Members",
        subtitle:
          "Create the profile of each of the members of your company. With the link to their Linkedin it will be much easier to give visibility to them and the company."
      },
      photo: {
        label: "Profile picture",
        help: "180x60, max 25MB"
      },
      name: "Surname and first name",
      position: "Position",
      linkedin: "LinkedIn",
      newMember: "Add member",
      table: "Your team",
      delete: "",
      design: {
        color: "Background color"
      }
    },

    descriptionForm: {
      title: "Description",
      subtitle:
        "Describe your organisation and your vision, mission and values.",
      motto: {
        label: "Motto",
        help: "Max. 40 characters."
      },
      description: "Brief description of your organisation",
      titleDescription: {
        label: "Description title",
        help: "Max. 40 characters."
      },
      secondaryImg: {
        label: "Secondary image",
        help: "180x60, max 25MB"
      },
      largeDescription: "Full description"
    },

    whyChooseUsForm: {
      title: "¿Why choose us?",
      subtitle: "Write here what makes you different from the rest",
      image: "Main image",
      imageHelperText: "180x60. Máx 25MB",
      formTitle: "Title",
      titleHelperText: "(Máx 80 characters)",
      description: "Description",
      titles: {
        1: "Title 1",
        2: "Title 2",
        3: "Title 3",
        4: "Title 4",
        helper: "(Max 30 characters)"
      },
      descriptions: {
        1: "Descriptive text 1",
        2: "Descriptive text 2",
        3: "Descriptive text 3",
        4: "Descriptive text 4"
      },
      design: {
        color: "Background color",
        layout: {
          tooltip: "Layout",
          title: "Main Title",
          subtitle: "Description",
          item: {
            title: "Title",
            subtitle: "Descriptive text"
          }
        }
      }
    },

    bookingsForm: {
      title: "Bookings",
      subtitle: "Give your users the opportunity to meet with you.",
      image: "Image",
      formTitle: "Title",
      formSubtitle: "Subtitle",
      imageHelper: "180x60. Max 25MB",
      titleHelper: "(Max 80 characters)",
      subtitleHelper: "(Max 140 characters)",
      button: "Button ",
      link: "Link to your booking page"
    },

    reviewsForm: {
      title: "Reviews",
      subtitle:
        "Link your website to your Google profile and let your users see your reviews.",
      formTitle: "Title",
      formSubtitle: "Subtitle",
      titleHelper: "(Max 80 characters)",
      subtitleHelper: "(Max 140 characters)",
      link: "Link to your Google My Business profile"
    },

    impactForm: {
      title: "Impact data",
      subtitle: "Modify the impact data visible on the website.",
      icon: {
        1: "Icon 1",
        2: "Icon 2",
        3: "Icon 3",
        4: "Icon 4",
        help: "60x60. Max 25MB"
      },
      text: {
        1: "Text impact 1",
        2: "Text impact 2",
        3: "Text impact 3",
        4: "Text impact 4"
      },
      amount: {
        1: "Amount impact 1",
        2: "Amount impact 2",
        3: "Amount impact 3",
        4: "Amount impact 4"
      },
      design: {
        color: "Text Color",
        backgroundColor: "Background Color",
        cardTextColor: "Card Text Color",
        cardAmountColor: "Amount Text Color"
      }
    },
    notify: {
      success: "Changes successfully saved",
      error: "An error occurred while saving",
      validationError: "Please fill in all the required fields",
      publishWebsiteError: "An error has ocurred while publishing your website",
      unpublishWebsiteError:
        "An error has ocurred while unpublishing your website"
    }
  }
};
